import { Service } from "./Service";
import { PageHead as HeadEntity } from "../Entity/PageHead";

export class PageHead extends Service {

    public applyHead(app: any): void {
        this.getHead().applyHead(app);
    }

    protected getHead(): HeadEntity {
        return this.get("head");
    }

    protected initialize(data?: any): void {
        super.initialize(data);
        this.addToData("head", new HeadEntity(data));
    }
}
